import { css } from '@emotion/react';

import { typeCourseCardCategory } from './type';
import {
  charcoalGrey,
  pinkishOrange,
  slickArrowHeight,
  slickArrowWidth,
  standardPaddingSm,
} from '../styled-variables';

export const buttonBase = css`
  font-weight: bold;
  text-transform: uppercase;
  margin: 0;
  font-weight: 0;
  height: 47px;
  display: inline-flex;
  vertical-align: middle;
  text-align: center;
  border-radius: 2px;
  letter-spacing: 1.8px;
  font-size: 0.6875rem; // 11px
  min-width: 220px;
  padding: 2px 30px 0;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  border: 2px solid transparent;
  transition: background-color 0.3s ease-in-out;
  line-height: normal;

  &:hover {
    text-decoration: none;
  }
`;

// Getting a bug where pinkishOrange is not being used.
// Using #ff642e until this is debugged.
export const buttonFilled = css`
  ${buttonBase};
  color: #fff;
  background: #ff642e;

  &:hover,
  &:focus {
    border-color: #ff642e;
    background-color: transparent;
    color: #ff642e;
  }
`;

export const buttonOutlineLight = css`
  ${buttonBase};
  color: #fff;
  border-color: #fff;

  &:hover,
  &:focus {
    background-color: #fff;
    color: ${charcoalGrey};
  }
`;

export const buttonOutlineDark = css`
  ${buttonBase};
  color: ${charcoalGrey};
  border-color: ${charcoalGrey};

  &:hover,
  &:focus {
    background-color: ${charcoalGrey};
    color: #fff;
  }
`;

export const buttonOutlineOrange = css`
  ${buttonBase};
  border-color: ${pinkishOrange};
  background-color: transparent;
  color: ${pinkishOrange};

  &:hover,
  &:focus {
    color: #fff;
    background: ${pinkishOrange};
  }
`;

export const buttonReset = css`
  background: none;
  border: none;
`;

export const buttonStandardOrange = css`
  ${buttonReset};
  font-size: 1rem;
  line-height: 1.63;
  color: ${pinkishOrange};
  text-decoration: underline;
`;

export const buttonCarouselArrow = css`
  border-radius: 50%;
  overflow: hidden;
  width: ${slickArrowWidth};
  height: ${slickArrowHeight};
  background-color: #fff;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  border: none;
  cursor: pointer;
`;

export const buttonRadio = css`
    display: none;

    &:checked + label span.radio::after {
        content: '\25C9';
        color: #000;
    }

    & + label span {
        &.radio {
            margin-left: 54px;

            &::after {
            content: '\25EF';
            left: 18px;
            bottom: 3px;
            border-radius: 10px;
            background-color: transparent;
            border: 1px solid #fff;
        }

        &:hover {
            cursor: pointer;
        }
    }

    &::before,
    &::after {
        content: '';
        position: absolute;
        top: 0;
        bottom: 0;
        margin: auto;
    }

    &::before {
        margin-left: ${standardPaddingSm};
    }
`;

export const buttonRelatedTopics = css`
  ${typeCourseCardCategory};
  margin-right: 8px;
  background-color: #bfbfbf;
  display: inline-flex;
  color: #27292d;
  border: none;
  border-radius: 4px;
  align-items: center;
  justify-content: center;
  height: 21px;

  &:hover {
    cursor: pointer;
  }
`;

export const buttonClose = css`
  ${buttonReset};
  position: relative;
  height: 20px;
  width: 20px;

  &:hover {
    cursor: pointer;
  }

  &::before,
  &::after {
    content: '';
    height: 2px;
    background-color: #fff;
    width: 100%;
    position: absolute;
    left: 0;
  }

  &::before {
    transform: rotate(45deg);
  }

  &::after {
    transform: rotate(-45deg);
  }
`;
